import React from "react";
import "../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import ScholarshipsRecessesForm from "./ScholarshipsRecessesForm";
import Transition from "components/layout/transition/Transition";
import { useQueryGetScholarshipHistory } from "../../../hooks/DataFetching/HR/ScholarshipRecesses/useQueryGetScholarshipHistory";

const CallEditScholarshipRecess = ({ match }) => {
  const { isFetching, isSuccess, data } = useQueryGetScholarshipHistory(
    match.params.id
  );

  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <Transition loading={isFetching} newDesign>
        <ScholarshipsRecessesForm
          context={"edit"}
          scholarshipRecessHistory={data}
          loading={isFetching}
          isSuccess={isSuccess}
        />
      </Transition>
    </div>
  );
};

export default CallEditScholarshipRecess;
